export default "__VITE_ASSET__a920fccd__"